export default __webpack_public_path__ + "static/media/avance.6c931ca0.jpg";